import ContentCard from 'scripts/models/api/cards/base/contentCard';
import can from 'can'

export default  ContentCard.extend({
    define: {
        video: {
            Type: can.Map,
            Value: null
        },
        isFeatured: {
            type: 'boolean',
            value: false
        }
    }
});